import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const formatBytes = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

const iconForMime = (mime) => {
  if (!mime) return '📎';
  if (mime.startsWith('image/')) return '🖼️';
  if (mime === 'application/pdf') return '📄';
  return '📎';
};

const MessageAttachment = ({ message }) => {
  if (!message?.has_attachment) return null;
  const url = `${API}/messages/${message.id}/attachment`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="mt-3 inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 transition text-sm max-w-full"
      data-testid={`message-attachment-${message.id}`}
    >
      <span className="text-base">{iconForMime(message.attachment_mime)}</span>
      <span className="font-medium text-gray-800 truncate" style={{ maxWidth: '220px' }}>
        {message.attachment_name || 'Anhang'}
      </span>
      {message.attachment_size ? (
        <span className="text-xs text-muted-foreground">{formatBytes(message.attachment_size)}</span>
      ) : null}
      <svg className="w-4 h-4 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    </a>
  );
};

export default MessageAttachment;
